/**
 * Urgency FOMO — theme storefront (buy buttons slot).
 *
 * Only activates when the Urgency FOMO app block is on the page
 * ([data-urgency-fomo-enable]). That way a theme push alone does not
 * show FOMO on live until the merchant adds the block.
 *
 * Debug: filter console with "[urgency-fomo]".
 */
(function () {
  if (window.__urgencyFomoBound) return;
  window.__urgencyFomoBound = true;

  var SESSION_PREFIX = "urgency_fomo_viewed:";
  var LOG = "[urgency-fomo]";

  function log() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG);
    console.log.apply(console, args);
  }

  function warn() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG);
    console.warn.apply(console, args);
  }

  function renderHtml(root, html) {
    var el = root.querySelector("[data-urgency-statement]");
    if (!el) {
      warn("missing [data-urgency-statement] inside block");
      return;
    }

    if (!html || typeof html !== "string") {
      root.hidden = true;
      el.textContent = "";
      log("hide block — no html from API");
      return;
    }

    el.innerHTML = html;
    root.hidden = false;
    log("rendered html", { length: html.length, preview: html.slice(0, 120) });
  }

  function alreadyTracked(productId) {
    try {
      return sessionStorage.getItem(SESSION_PREFIX + productId) === "1";
    } catch (e) {
      return false;
    }
  }

  function markTracked(productId) {
    try {
      sessionStorage.setItem(SESSION_PREFIX + productId, "1");
    } catch (e) {
      /* private mode */
    }
  }

  function trackView(apiUrl, productId) {
    if (!apiUrl || !productId) return;
    if (alreadyTracked(productId)) {
      log("skip view ping — already tracked this session", {
        productId: productId,
      });
      return;
    }
    markTracked(productId);

    var trackUrl = String(apiUrl).replace(
      /\/api\/urgency\/?$/,
      "/api/urgency/view",
    );
    if (trackUrl === apiUrl) {
      trackUrl = String(apiUrl).replace(/\/?$/, "") + "/view";
    }

    var body = "product_id=" + encodeURIComponent(productId);
    log("view ping", { trackUrl: trackUrl, productId: productId });

    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([body], {
          type: "application/x-www-form-urlencoded",
        });
        if (navigator.sendBeacon(trackUrl, blob)) return;
      }
    } catch (e) {
      /* continue */
    }

    try {
      fetch(trackUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
          "ngrok-skip-browser-warning": "1",
        },
        body: body,
        credentials: "omit",
        keepalive: true,
      }).catch(function (err) {
        warn("view ping failed", err);
      });
    } catch (e) {
      warn("view ping error", e);
    }
  }

  function loadBlock(root, apiUrl, productId) {
    if (root.getAttribute("data-urgency-loaded") === "1") return;
    root.setAttribute("data-urgency-loaded", "1");

    root.setAttribute("data-api-url", apiUrl);
    root.setAttribute("data-product-id", productId);

    log("init slot", {
      productId: productId,
      apiUrl: apiUrl,
      id: root.id || null,
    });

    if (!productId || !apiUrl) {
      root.hidden = true;
      warn("missing product id or api url");
      return;
    }

    var url =
      apiUrl +
      (apiUrl.indexOf("?") >= 0 ? "&" : "?") +
      "product_id=" +
      encodeURIComponent(productId);

    log("GET", url);

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "ngrok-skip-browser-warning": "1",
      },
      credentials: "omit",
    })
      .then(function (response) {
        log("response", {
          status: response.status,
          ok: response.ok,
          contentType: response.headers.get("content-type"),
        });
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.json();
      })
      .then(function (data) {
        log("payload", data);
        if (!data || !data.ok) {
          root.hidden = true;
          warn("API returned not-ok — hide block", data);
          return;
        }
        renderHtml(root, data.html);
        trackView(apiUrl, productId);
      })
      .catch(function (err) {
        root.hidden = true;
        warn("fetch failed (CORS, wrong API URL, or tunnel down)", err);
      });
  }

  function init() {
    var enable = document.querySelector("[data-urgency-fomo-enable]");
    var slots = document.querySelectorAll("[data-urgency-fomo]");

    if (!enable) {
      log("no Urgency FOMO app block on page — keep slot hidden");
      slots.forEach(function (el) {
        el.hidden = true;
        el.setAttribute("data-urgency-loaded", "0");
      });
      return;
    }

    var apiUrl =
      enable.getAttribute("data-api-url") ||
      (slots[0] && slots[0].getAttribute("data-theme-api-url")) ||
      "";
    var productId =
      enable.getAttribute("data-product-id") ||
      (slots[0] && slots[0].getAttribute("data-product-id")) ||
      "";

    log("app block enabled", {
      apiUrl: apiUrl,
      productId: productId,
      slots: slots.length,
    });

    if (!slots.length) {
      warn("app block present but buy-buttons slot missing");
      return;
    }

    slots.forEach(function (root) {
      loadBlock(root, apiUrl, productId);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
